import { BehaviorSubject, combineLatest } from "rxjs";
import { map, tap } from "rxjs/operators";

class ImageViewerController {
    currentIndex$ = new BehaviorSubject<number | null>(null);
    private images$ = new BehaviorSubject<string[]>([]);
    currentImage$ = new BehaviorSubject<null | string>(null);
    imagesLength$ = new BehaviorSubject(0);
    hasNext$ = new BehaviorSubject(false);
    hasPrev$ = new BehaviorSubject(false);

    constructor() {
        combineLatest(this.currentIndex$, this.images$)
            .pipe(
                tap(([currentIndex, images]) => {
                    const hasNext = currentIndex !== images.length - 1;
                    const hasPrev = currentIndex !== 0;

                    this.hasNext$.next(hasNext);
                    this.hasPrev$.next(hasPrev);
                }),
                map(([currentIndex, images]) => {
                    if (currentIndex == null) return null;
                    return images[currentIndex];
                })
            )
            .subscribe(this.currentImage$);

        this.images$
            .pipe(
                map((images) => {
                    return images.length;
                })
            )
            .subscribe(this.imagesLength$);
    }

    next() {
        const currentIndex = this.currentIndex$.getValue();
        const imagesLength = this.imagesLength$.getValue();
        if (currentIndex === null || currentIndex >= imagesLength - 1) return;
        this.currentIndex$.next(currentIndex + 1);
    }

    prev() {
        const currentIndex = this.currentIndex$.getValue();
        if (currentIndex === null || currentIndex < 1) return;
        this.currentIndex$.next(currentIndex - 1);
    }

    openImage(images: string[], idx: number) {
        this.currentIndex$.next(idx);
        this.images$.next(images);
    }

    closeImage() {
        this.currentIndex$.next(null);
        this.images$.next([]);
        this.closeFullScreen();
    }

    closeFullScreen() {
        if (document.fullscreenElement && document.exitFullscreen) {
            void document.exitFullscreen();
        }
    }

    toggeleFullscreen() {
        if (!document.fullscreenElement) {
            void document.documentElement.requestFullscreen();
        } else {
            if (document.exitFullscreen) {
                void document.exitFullscreen();
            }
        }
    }
}

export default ImageViewerController;
